export default __webpack_public_path__ + "static/media/file.59083f5a.svg";